import URL from 'url'
import { get, omitBy, isNil, capitalize } from 'lodash'
import Cookies from 'js-cookie'

const endpoint = get(process.env, 'NODE_ENV') === 'development'
  ? 'https://dev-api.sabuywedding.com' : 'https://sabuy-api.sabuywedding.com'
const endpointV4 = get(process.env, 'NODE_ENV') === 'development'
  ? 'http://localhost:3003' : 'https://mcs.sabuywedding.com'
  // ? 'https://dev-mcs.sabuywedding.com' : 'https://mcs.sabuywedding.com'

const S3_PREFIX_NEW = 'https://sabuywedding.s3.ap-southeast-1.amazonaws.com/images/'
const S3_PREFIX = 'https://s3-ap-southeast-1.amazonaws.com/sabuywedding/images/'
const S3_PREFIX_DEPRECATED = 'https://s3-ap-southeast-1.amazonaws.com/sabuywedding/img/'

export const isDevelopment = get(process.env, 'NODE_ENV') === 'development'

export const getTheme = (propName, done) =>
  props => done ? done(props.theme[propName[0]]) : props.theme[propName[0]]

export const apiFetch = ({ key, fullUrl, v4, headers = {}, dispatch, url, token, method, query = {}, body, form, actionParams }) => {
  const dispatchable = key && dispatch
  if (dispatchable) dispatch({ type: `${key}_ATTEMPT` })
  return fetch(`${fullUrl || `${v4 ? endpointV4 : endpoint}${encodeURI(url)}`}${URL.format({ query })}`, omitBy({
    method: method || (body ? 'POST' : 'GET'),
    headers: omitBy({
      'Content-Type': `${form ? 'application/x-www-form-urlencoded' : 'application/json'}; charset=utf-8`,
      'Authority-Type': 'vendor',
      'Token': token || Cookies.get('sbwshop-token'),
      ...headers
    }, isNil),
    body: form || (body ? JSON.stringify(body) : undefined)
  }, isNil))
    .then(res =>
      res.json()
        .then(json => {
          if (res.status === 200) {
            if (dispatchable) dispatch({ type: `${key}_SUCCESS`, result: json, actionParams })
            return Promise.resolve(json)
          } else {
            if (dispatchable) dispatch({ type: `${key}_FAILURE`, reason: json.reason, actionParams })
            return Promise.reject({ statusCode: res.status, reason: json.reason }) // eslint-disable-line
          }
        })
        .catch(error => {
          console.log({ error })
          if (dispatchable) dispatch({ type: `${key}_FAILURE`, reason: get(error, 'reason'), actionParams })
          return Promise.reject({ statusCode: res.status, reason: get(error, 'reason') }) // eslint-disable-line
        })
    )
}

export const validateEmail = (email) =>
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email) // eslint-disable-line

const getXMLHttpRequest = ({ token, method, endpoint, resolve, onProgress }) => {
  let xhr = new XMLHttpRequest() //eslint-disable-line
  xhr.open(method, endpoint)
  xhr.upload.onerror = (errorEvent) => {
    console.error('upload error', errorEvent)
  }
  if (onProgress) xhr.upload.onprogress = onProgress
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4) {
      try {
        resolve({ ok: true, data: JSON.parse(xhr.responseText) })
      } catch (err) {
        resolve({ ok: false, data: xhr.responseText })
      }
    }
  }
  xhr.setRequestHeader('Accept', 'application/json, text/plain, */*')
  xhr.setRequestHeader('Cache-Control', 'no-cache')
  xhr.setRequestHeader('ContentType', 'application/json')
  xhr.setRequestHeader('Authority-Type', 'vendor')
  xhr.setRequestHeader('Token', token || Cookies.get('sbwshop-token'))

  return xhr
}

export const uploadToS3 = ({ url, file }) => {
  let xhr = new XMLHttpRequest() // eslint-disable-line
  xhr.open('PUT', url, true)
  xhr.send(file)
  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(url.split('?')[0])
      } else {
        reject(xhr.status)
      }
    }
  })
}

export const uploadFile = ({ dispatch, manualAttempt, fullUrl, key, fieldName, file, body = {}, url, token, actionParams = {}, method = 'POST', progressCallback = () => {} }) => {
  if (!manualAttempt && dispatch) dispatch({ type: `${key}_ATTEMPT`, ...actionParams, ...body })
  return new Promise((resolve, reject) => {
    const onProgress = dispatch
      ? (e) => dispatch({ type: `${key}_PROGRESS`, file, percent: (100 * e.loaded / e.total).toFixed(0) })
      : (e) => progressCallback(e, file) || (() => {})
    let xhr = getXMLHttpRequest({ token, method, endpoint: `${fullUrl || `${endpoint}${encodeURI(url)}`}`, onProgress, resolve })
    let formData = new FormData() //eslint-disable-line
    formData.append(fieldName, file)
    Object.keys(body).forEach(key => {
      formData.append(key, body[key])
    })

    xhr.send(formData)
  }).then(result => {
    if (dispatch) dispatch({ type: `${key}_SUCCESS`, result: result.data, ...actionParams, ...body })
    return Promise.resolve(result.data)
  }).catch(err => {
    console.error(err)
    if (dispatch) dispatch({ type: `${key}_FAILURE`, err, ...actionParams, ...body })
    return Promise.reject(err)
  })
}

export const toMap = (array, key) =>
  array.reduce((map, object, index) => ({ ...map, [key ? object[key] : index]: object }), 0)

export const viewportWidth = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 0
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

export const viewportHeight = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 0
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
}

export const timestamp = (_id = '') =>
  _id ? new Date(parseInt(_id.toString().substring(0, 8), 16) * 1000) : ''

export const formatComma = (number = '') =>
  (isNaN(number) ? number.replace(/,/g, '') : `${number}`).replace(/./g, (c, i, a) => i && c !== '.' && ((a.length - i) % 3 === 0) ? ',' + c : c)

export const deviceRatio = () => {
  let ratio = 1
  if (typeof window === 'undefined') return ratio

  if (window.screen.systemXDPI !== undefined &&
  window.screen.logicalXDPI !== undefined &&
  window.screen.systemXDPI > window.screen.logicalXDPI) {
    ratio = window.screen.systemXDPI / window.screen.logicalXDPI
  } else if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio
  }
  return 2
  // return ratio
}

export const toWidth = (path = '', width, ignoreRatio) => {
  if (typeof path !== 'string' || !width || path.indexOf('.gif') > -1) return path
  const segments = decodeURI(path.trim()).replace(/ /g, '+').split('?')
  const queryString = `width=${(width || 2) * (ignoreRatio ? 1 : deviceRatio())}${segments.length > 1 ? '&' + segments[1] : ''}`
  return (path.indexOf(S3_PREFIX) === -1 && path.indexOf(S3_PREFIX_DEPRECATED) === -1 && path.indexOf(S3_PREFIX_NEW) === -1) ? path
    : `https://resize.sabuywedding.com/${segments[0].replace(S3_PREFIX, '').replace(S3_PREFIX_DEPRECATED, '').replace(S3_PREFIX_NEW, '')}?${queryString}`
}

export const createReducer = (initialState = {}, asyncConfig = {}, syncConfig = {}) => {
  const { combinedState, handlers } = Object.keys(asyncConfig).reduce(({ combinedState, handlers }, key, index) => {
    const callback = asyncConfig[key]
    const prefix = key.toLowerCase().split('_').reduce((_key, string, index) =>
      index === 0 ? string : `${_key}${capitalize(string)}`
      , '')
    const onAttempt = callback.onAttempt || (() => ({}))
    const onProgress = callback.onProgress || (() => ({}))
    const onSuccess = callback.onSuccess || (() => ({}))
    const onFailure = callback.onFailure || (() => ({}))
    return {
      combinedState: { ...combinedState, [`${prefix}Attempting`]: false, [`${prefix}Attempted`]: false },
      handlers: {
        ...handlers,
        [`${key}_ATTEMPT`]: (state, action) =>
          ({ ...state, [`${prefix}Attempting`]: true, [`${prefix}Attempted`]: false, ...onAttempt(state, action) }),
        [`${key}_PROGRESS`]: (state, action) =>
          ({ ...state, ...onProgress(state, action) }),
        [`${key}_SUCCESS`]: (state, action) =>
          ({ ...state, [`${prefix}Attempting`]: false, [`${prefix}Attempted`]: true, [`${prefix}Error`]: null, ...onSuccess(state, action) }),
        [`${key}_FAILURE`]: (state, action) =>
          ({ ...state, [`${prefix}Attempting`]: false, [`${prefix}Attemted`]: false, [`${prefix}Error`]: action.error, ...onFailure(state, action) })
      }
    }
  }, { combinedState: initialState, handlers: syncConfig })
  return (state = combinedState, action) =>
    handlers[action.type] ? handlers[action.type](state, action) : state
}

export const placeholder = (value) => `
  &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    ${value}
  }
  &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  ${value}
  opacity:  1;
  }
  &::-moz-placeholder { /* Mozilla Firefox 19+ */
  ${value}
  opacity:  1;
  }
  &:-ms-input-placeholder { /* Internet Explorer 10-11 */
  ${value}
  }
`

export const noSelect = `
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const getYoutubeId = (url = '') => {
  const match = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/) // eslint-disable-line
  return (match && match.length > 2 && match[2].length === 11) ? match[2] : ''
}

export const getVimeoId = (url = '') => {
  const match = url.match(/^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/)
  return (match && match.length > 5 && match[5]) ? match[5] : ''
}

export const track = () => {

}



// WEBPACK FOOTER //
// ./src/helpers.js